'use strict'

export const expandable = (() => {
  const isClamped = element => {
    const range = document.createRange();
    range.selectNodeContents(element);
    const fullTextHeight = range.getBoundingClientRect().height;

    const computedStyle = window.getComputedStyle(element);
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const clampLines = parseInt(computedStyle.webkitLineClamp, 10);

    if (isNaN(lineHeight) || isNaN(clampLines)) {
      return false;
    }

    const clampHeight = lineHeight * clampLines;

    return fullTextHeight > clampHeight;
  }

  const setPreviewHeight = () => {
    const expandables = document.querySelectorAll('.expandable')

    expandables.forEach(expandable => {
      const section = expandable.closest('section')

      if (!section) return

      const preview = section.querySelector('.preview')
      const showMoreButton = expandable.nextElementSibling

      if (!preview || !showMoreButton) return

      let previewHeight = 0

      // If preview is not clamped in fact, hide expandable and show more button
      if (isClamped(preview)) {
        expandable.classList.remove('hidden!')
        showMoreButton.classList.remove('hidden!')
        preview.classList.remove('static!')
        previewHeight = preview.getBoundingClientRect().height
      } else {
        expandable.classList.add('hidden!')
        showMoreButton.classList.add('hidden!')
        preview.classList.add('static!')
      }

      section.style.setProperty('--preview-height', `${previewHeight}px`)
    })
  }

  const init = () => {
    window.addEventListener('resize', setPreviewHeight)
    setPreviewHeight()
  }

  return {
    init
  }
})()